<ng-container [formGroup]="form">
  <div >
    <label for="streetAddress" class="required">Street Address</label>
    <input pInputText id="streetAddress" formControlName="streetAddress" />
    <error-block [field]="form.controls.streetAddress" [messages]="{
      required: 'Street Address is required.'
    }"></error-block>
  </div>

  <div >
    <label for="location" class="required">City/State/Postal Code</label>
    <location-search inputId="location" formControlName="location"></location-search>
    <error-block [field]="form.controls.location" [messages]="{
      required: 'City/State/Postal Code is required.'
    }"></error-block>
  </div>

  <div >
    <label class="required">Normalized Address</label>
    @if (loadingNormalization) {
      <div class="normalized-address-loading" aria-live="polite">
        <span class="pi pi-spin pi-spinner" aria-hidden="true"></span> Loading suggestions...
      </div>
    }
    @if (!loadingNormalization && normalizedAddresses.length > 0) {
      <fieldset class="radio-option-list">
        <legend class="p-sr-only">Select a normalized address</legend>
        @for (address of normalizedAddresses; track address; let i = $index) {
          <div
            class="radio-option-item"
            role="button"
            (click)="selectAddress(address)"
            >
            <p-radioButton
              name="selectedNormalizedAddress"
              [value]="address"
              formControlName="selectedNormalizedAddress"
              [inputId]="'normalizedAddress' + i">
            </p-radioButton>
            <label [for]="'normalizedAddress' + i">
              @if (address.isParsedFromQuery) {
                <span>Use as entered: </span>
              }
              {{ address.address1 }}, {{ address.city }}, {{ address.state }} {{ address.postalCode }}
            </label>
          </div>
        }
      </fieldset>
    }
    @if (!loadingNormalization && !searchCompleted) {
      <div class="normalization-hint">
        Enter a valid address to see suggestions.
      </div>
    }
    @if (!loadingNormalization && searchError) {
      <div class="normalization-error" role="alert">
        <span class="pi pi-exclamation-triangle" aria-hidden="true"></span> Failed to normalize address. Please try again.
      </div>
    }
  </div>
</ng-container>
